<template>
    <section id="cta-content-downloadable">

        <CTABanner :onlyBanner="true" :bannerData="{bannerText: 'SEE SIGN UP', href:'/sign-up'}"/>

    </section>
</template>

<script>

import CTABanner from "../CTABanner.vue";

export default {
    components: {
        CTABanner
    },
    data() {
        return {
        }
    }


}
</script>